import { useEffect, useState } from 'react'

import type { TabsProps } from './types'

import * as S from './styles'

export const Tabs = ({ tabs, onChange, variant = 'standard', centered = false, selectedTab }: TabsProps) => {
  const [activeTab, setActiveTab] = useState<number | null>(null)

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
    onChange?.(newValue + 1)
  }

  useEffect(() => {
    setActiveTab(selectedTab ? selectedTab - 1 : null)
  }, [selectedTab])

  return (
    <S.Container>
      <S.Tabs
        value={activeTab}
        onChange={handleChange}
        variant={variant}
        centered={centered}
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab, index) => (
          <S.Tab
            key={index}
            label={tab.label}
            disabled={tab.disabled}
            id={`tab-${index}`}
            aria-controls={`tabpanel-${index}`}
          />
        ))}
      </S.Tabs>

      {tabs.map((tab, index) => (
        <S.Content
          key={index}
          role="tabpanel"
          hidden={activeTab !== index}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
        >
          {activeTab === index && tab.content}
        </S.Content>
      ))}
    </S.Container>
  )
}
